import { Select, Badge } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllOPOrganizationAction } from 'src/modules/SuperAdmin/store/actions/organization.action';
import OfficePracticumPage from 'src/modules/ambient_solo/components/TemplateAdmin/EHR/officepracticum.page';

const OPCredentials = () => {
  const dispatch = useDispatch();
  const { hQOrganizationsList } = useSelector(
    (state) => state?.organizationState
  );
  const [selectedOrgUuid, setSelectedOrgUuid] = useState(null);
  const [orgSearchTerm, setOrgSearchTerm] = useState('');

  useEffect(() => {
    dispatch(getAllOPOrganizationAction());
  }, [dispatch]);

  const organizationOptions = useMemo(() => {
    if (!Array.isArray(hQOrganizationsList)) return [];
    return hQOrganizationsList
      .filter(
        (org) =>
          !orgSearchTerm ||
          org?.org_name?.toLowerCase().includes(orgSearchTerm.toLowerCase())
      )
      .map((org) => ({
        value: org?.org_uuid,
        label: (
          <Badge
            count={org?.user_count}
            overflowCount={99}
            offset={[20, 7]}
            style={{ backgroundColor: '#52c41a' }}
            showZero={true}
          >
            <span className="mr-1">{org?.org_name}</span>
          </Badge>
        ),
        name: org?.org_name,
      }));
  }, [hQOrganizationsList, orgSearchTerm]);

  return (
    <div className="flex-1 pt-4">
      <div className="bg-white rounded-lg shadow-sm p-6">
        <div className="flex flex-col gap-3">
          <div className="text-lg font-bold font-sans pl-1">
            Office Practicum Credentials
          </div>
          <div className="flex flex-col gap-2 w-full md:w-2/3">
            <label className="text-sm font-medium text-gray-700 pl-1">
              Organization
            </label>
            <Select
              showSearch
              allowClear
              filterOption={false}
              onSearch={setOrgSearchTerm}
              placeholder="Select an organization"
              value={selectedOrgUuid || undefined}
              onChange={(value) => setSelectedOrgUuid(value || null)}
              options={organizationOptions}
            />
          </div>
          {selectedOrgUuid && (
            <OfficePracticumPage
              key={selectedOrgUuid}
              orgUuid={selectedOrgUuid}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default OPCredentials;
